import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IOpportunityMSDocument } from '~/types/document/models'

export const {
  getDocumentListData: getOpportunityMSDocumentListData,
  getDocumentDataById: getOpportunityMSDocumentDataById,
  getDocumentListDataByParentId: getOpportunityMSDocumentListDataByOMSId,
} = makeDocumentMockData<IOpportunityMSDocument>({
  entityName: 'opportunityMasterService',
  storageKeyPrefix: 'opportunityms',
})
